import { Button, Group, Tooltip } from "@mantine/core"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { icons } from "../utils"
import { type IUserSelectProps, UserSelect } from "./UserSelect"

export function UserAdd({ size, onChange, ...props }: IUserSelectProps) {
  const { t } = useTranslation()
  const [selected, setSelected] = useState<string | null>()

  return (
    <Group wrap="nowrap" gap={4} w="100%">
      <UserSelect
        placeholder={t("Add an employee")}
        value={selected}
        onChange={setSelected}
        selectFirstOptionOnChange
        size={size}
        flex={1}
        {...props}
      />
      <Tooltip label={t("Add")}>
        <Button
          size={size}
          color="blue"
          disabled={!selected || props.disabled}
          onClick={() => {
            setSelected(null)
            onChange?.(selected!, null as any)
          }}
          variant="filled"
        >
          <icons.Add />
        </Button>
      </Tooltip>
    </Group>
  )
}
